module.exports = __webpack_public_path__ + "assets/monitor.e3872b3f.svg";